import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import './assets/theme/theme-darkblue/index.css'
import store from '@/store'
import Vuex from 'vuex'
import router from '@/router'
import Mock from '@/api/mock'
import VueClipboard from 'vue-clipboard2'
Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.min.css'
import "babel-polyfill"
import global from '@/config/global_config'
import tipnotes from './components/tipnotes'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// import ssl-root-cas from 'ssl-root-cas'
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.use(VueQuillEditor)

let localRoutes = sessionStorage.getItem('localRoutes');
if(localRoutes){
  let dynamicRouter =[];
  JSON.parse(localRoutes).forEach(one => {
    if(one.path == '\/'){
        let temp;
        temp = {path: '/',component:(resolve) => require(['@/pages/Home.vue'], resolve),name:one.name,iconCls:one.iconCls,children:[]}
        one.children.forEach(element => {
          let componentPath = element.path;
          temp.children.push({path:element.path,component:global.routerPathMap[element.path.substr(1)],name:element.name}); 
        });
        router.options.routes.push(temp);
        dynamicRouter.push(temp);
    }
  });
  router.addRoutes(dynamicRouter);
}

new Vue({
  router,
  store,
  component: {tipnotes},
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js